// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"c28b999b","782":"58f0c49e","954":"491dc4b2"}[chunkId] + ".chunk.css";
};